import React from 'react';
import UserManagementLayout from '../components/users/UserManagementLayout';

const Users = () => {
    return <UserManagementLayout />;
};

export default Users;
